<template>
  <div class="eventDetails">
    <el-card class="card1" shadow="never">
      <div class="title">
        <img
          class="img1"
          src="../../assets/images/ticons/pepoleactive_icon@2x.png"
          alt=""
        />
        <span style="font-weight:500;">用户活跃度</span>
        <img
          class="img2"
          src="../../assets/images/ticons/details_customerbianji_icon@2x.png"
          alt=""
        />
      </div>
      <div class="text">30天内用户访问次数透视</div>
    </el-card>
    <el-card shadow="never" class="card2">
      <div class="btn2">
        <el-radio-group
          v-model="tabPosition"
          style="margin-bottom: 30px"
          class="ft"
        >
          <el-radio-button label="1">人数分布</el-radio-button>
          <el-radio-button label="2">历史详情</el-radio-button>
        </el-radio-group>
      </div>
      <!-- 人数分布配置  -->
      <div v-show="tabPosition == 1" class="peopleNum">
        <p style="margin: 0 0 10px 15px">
          <span style="font-size: 14px">总人数 ｜</span
          ><span class="color7">计算时间为每日0点</span>
        </p>
        <p class="colorBule fz43" style="font-weight: bold">
          1,360<span class="fz14" style="font-weight: 500">人</span>
        </p>
        <div id="e1"></div>
      </div>
      <!-- 历史详情 -->
      <div v-if="tabPosition == 2" class="history">
        <!-- 日期组件 -->
        <div class="datepic">
          <el-date-picker
            @blur="datec"
            v-model="value1"
            type="daterange"
            range-separator="→"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <!-- 叠柱图 -->
        <history></history>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
import history from "./components/history.vue";
export default {
  components: {
    history,
  },
  data() {
    return {
      //开关切换
      tabPosition: "1",
      //日期事件
      value1: "",
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    //日期组件事件
    datec() {
      console.log("aa", this.value1);
    },
    // 图1
    init() {
      const data = [
        { type: "1次", value: 79 },
        { type: "2次", value: 70 },
        { type: "3次", value: 75 },
        { type: "4次", value: 100 },
        { type: "5次", value: 65 },
        { type: "其它", value: 77 },
      ];
      const chart = new Chart({
        container: "e1",
        autoFit: true,
        height: 350,
        padding: [0, 50, 50, 50],
      });

      chart.axis("type", {
        tickLine: null, // 不显示刻度线
      });
      // 自定义图例
      chart.legend({
        custom: true,
        items: [
          {
            name: "人数分布",
            id: "type",
            marker: { symbol: "square", style: { r: 4, fill: "#6395f9" } },
          },
        ],
      });
      // 显示Y轴的竖线
      chart.axis("value", {
        line: {
          style: {
            lineWidth: 1,
            stroke: "#BFBFBF",
          },
        },
      });

      chart.tooltip({
        showCrosshairs: false,
        shared: false,
        showMarkers: false, //移入图表展示圆点
      });

      chart.data(data);
      chart.scale({
        value: {
          max: 100,
          min: 0,
          tickCount: 6, //设置刻度个数
        },
      });
      //
      chart.coordinate().transpose();
      chart
        .interval()
        .position("type*value")
        .size(26)
        .label("value", (value) => {
          return {
            content: value + "%", //对数据标签修改后输出
          };
        });
      chart.interaction("element-active");
      chart.render();
    },
  },
};
</script>

<style lang='less'>
.eventDetails {
  padding: 20px;
  //顶部样式区
  .card1 {
    .title {
      display: flex;

      span {
        font-weight: 600;
        font-size: 16px;
        color: #333940;
      }
      .img1 {
        width: 20px;
        margin-right: 10px;
      }
      .img2 {
        width: 16px;
        height: 16px;
        margin-left: 10px;
        transform: translateY(3px);
      }
    }
    .text {
      width: 193px;
      height: 38px;
      background: rgba(115, 160, 250, 0.3);
      border-radius: 19px;
      color: #0091ff;
      line-height: 38px;
      font-size: 14px;
      text-align: center;
      font-weight: 600;
      margin-top: 20px;
      margin-left: 0px;
    }
  }
  .card2 {
    margin-top: 30px;
    height: 1100px;
    position: relative;
    //两个按钮
    .btn2 {
      .ft {
        .el-radio-button:first-child .el-radio-button__inner {
          border-radius: 18px 0 0 18px;
          width: 81px;
        }
        .el-radio-button:last-child .el-radio-button__inner {
          border-radius: 0 18px 18px 0;
          width: 81px;
        }
      }
    }
    .datepic {
      position: absolute;
      top: 20px;
      right: 30px;
      .el-range-editor--mini.el-input__inner {
        width: 200px;
      }
      .el-date-editor .el-range-separator {
        padding: 0px 4px;
        line-height: 18px;
        width: 5%;
        color: #c6c8cc;
      }
    }
  }
  //公共样式区
  .fz43 {
    font-size: 43px;
  }
  .fz14 {
    font-size: 14px;
  }
  .color7 {
    color: #777777;
    font-size: 12px;
    margin-left: 10px;
  }
  .colorBule {
    color: #327eff;
  }
}
</style>